export default [{
  path: '/tranformDetail',
  name: 'tranformDetail',
  meta: {
    index: 1
  },
  params:{},
  component: () => import('@/views/tranformDetail/index'),
}]
